import Swiper, { Pagination } from 'swiper';

var references = {

    ui: {},

    init: function() {
        // this.bindUI();
        // this.bindEvents();
        this.initSlider();
    },

    // bindUI: function() {
    //     this.ui.$references = $(".js-references");
    //     this.ui.$referencesContainer = $(".js-references-container");
    //     this.ui.$referenceItem = $(".js-reference-item");

    //     this.ui.$referencesCursor = $(".js-references-cursor");
    // },

    // bindEvents: function() {
    //     this.ui.$references.on('mousemove', this.sectionHover.bind(this));
    //     this.ui.$referenceItem.on('mouseover', e => {
    //         this.sectionHover(e)
    //         this.itemHoverIn(e)
    //     });
    //     this.ui.$referenceItem.on('mouseout', this.itemHoverOut.bind(this));
    // },

    // sectionHover: function(e) {
    //     let left = e.pageX - this.ui.$referencesContainer.offset().left
    //     let top = e.pageY - this.ui.$referencesContainer.offset().top
    //     let width = this.ui.$referencesCursor.outerWidth()
    //     let height = this.ui.$referencesCursor.outerHeight()
    //     let x = left - (width / 2)
    //     let y = top - (height / 2)

    //     // this.ui.$referencesCursor.css('transform', 'translate('+ x +'px,'+ y +'px)')
    //     this.ui.$referencesCursor.css('left', x +'px')
    //     this.ui.$referencesCursor.css('top', y +'px')
    // },

    // itemHoverIn: function(e) {
    //     this.ui.$references.addClass('is-hover')
    // },

    // itemHoverOut: function(e) {
    //     this.ui.$references.removeClass('is-hover')
    // },

    initSlider: function initSlider() {
		
        const sliderEl = document.querySelector('.js-refcardlist-slider');

        const swiperInst = new Swiper(sliderEl, {
            slidesPerView: 1, 
            spaceBetween: 30,
            autoHeight: true,
            modules: [Pagination],
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            }
        })

	},

};

module.exports = references;
